import _extends from "@babel/runtime/helpers/extends";
import { Box, Heading, Text } from '@wix/design-system';
import clsx from 'clsx';
import React from 'react';
import { HeaderWrapper } from '../HeaderWrapper';
import s from './resultsHeader.scss';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
export const ResultsHeader = _ref => {
  let {
    onBackClick,
    isMailboxReferral = false,
    isResultsPageOptimizations = false,
    offsetTitle = false,
    topAligned = false,
    ...props
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const alignHeaderToTop = topAligned || offsetTitle;
  const titleKey = isMailboxReferral ? 'domain_search_gate.business_email_results.title' : isResultsPageOptimizations ? 'domains_search_gate.results_optimization.bm.title' : 'domain_search_gate.results.header_ai';
  return /*#__PURE__*/React.createElement(HeaderWrapper, _extends({
    onBackClick: onBackClick,
    verticalAlign: alignHeaderToTop ? 'top' : 'middle'
  }, props), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    align: "center",
    gap: "SP2",
    className: clsx(s.headingGap, offsetTitle && s.offsetTitle)
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.resultsHeaderTitle
  }, t(titleKey)), isMailboxReferral && /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal",
    secondary: true
  }, t('domain_search_gate.business_email_results.subtitle'))));
};
//# sourceMappingURL=ResultsHeader.js.map